import { useTranslation } from 'react-i18next';
import '../../../../../css/web/bedloophotel/empresa.css';

// Prefix d'idioma de la URL actual (/en/..., /fr/...): l'espanyol no en porta.
const prefijoIdioma = () => {
    const segmento = window.location.pathname.split('/')[1];
    return /^(en|fr|it|pt|ru|de|sv|ca|cs|nl)$/.test(segmento) ? segmento + '/' : '';
};

// Hero de les pàgines interiors (empresa, legals, blog, ajuda...): imatge a
// sang amb títol gran i etiqueta translúcida, amb les molles de pa alineades
// a la vora esquerra del hero. Sense imatge queda un degradat fosc; "compacto"
// és la versió baixa. "migas" permet un recorregut propi ([{label, href}]);
// per defecte és Inicio > títol. "logo" (URL) és la capa de sota de la foto:
// sense foto, o si la foto no carrega, es veu el logo corporatiu en lloc
// d'un espai en blanc.
const CabeceraPagina = ({ titulo, eyebrow, imagen, logo, compacto = false, migas }) => {

    const { t } = useTranslation();

    const recorrido = migas || [
        { label: t("Inicio"), href: "/" + prefijoIdioma() },
        { label: titulo },
    ];

    return (
        <>
            <nav className="bhe-migas" aria-label="breadcrumb">
                {recorrido.map((miga, index) => {
                    const ultima = index === recorrido.length - 1;
                    return (
                        <span className="bhe-migas__item" key={index}>
                            {index > 0 && <i className="fa-solid fa-chevron-right" aria-hidden="true"></i>}
                            {miga.href && !ultima
                                ? <a href={miga.href}>{miga.label}</a>
                                : <span aria-current={ultima ? "page" : undefined}>{miga.label}</span>}
                        </span>
                    );
                })}
            </nav>

            <section className={"bhe-hero" + (compacto || !imagen ? " bhe-hero--compacto" : "") + (!imagen && logo ? " bhe-hero--logo" : "")}>
                {(imagen || logo) && (
                    <div
                        className={"bhe-hero__media" + (logo ? " bhe-hero__media--logo" : "")}
                        role="img"
                        aria-label={titulo}
                        style={{ backgroundImage: [imagen, logo].filter(Boolean).map((u) => "url('" + u + "')").join(", ") }}
                    ></div>
                )}
                <div className="bhe-hero__scrim"></div>
                <div className="bhe-hero__content">
                    {eyebrow && <span className="bhe-eyebrow">{eyebrow}</span>}
                    <h1 className="bhe-hero__title">{titulo}</h1>
                </div>
            </section>
        </>
    );
};

export default CabeceraPagina;
